// Reseñas destacadas (estáticas). Antes venían del backend /api/public/reviews;
// el sitio ahora es estático, así que se sirven desde acá.
export const REVIEWS = [
  {
    author: "Felipe",
    location: "Medellín, Colombia",
    content_en:
      "Diego is a great host; the experience, the place, and the food were all spectacular. He gave us great tips and information about the asado, and he made us feel at home and like part of his family. I highly recommend the experience.",
    content_es:
      "Diego es un anfitrión increíble; la experiencia, el lugar y la comida fueron espectaculares. Nos dio tips e información sobre el asado, y nos hizo sentir como en casa y parte de su familia. Recomiendo 100% la experiencia.",
  },
  {
    author: "Valentina",
    location: "Oak Park, MI",
    content_en:
      "We loved our experience! Everything was great - the host, place, food, company. We enjoyed our evening very much!",
    content_es:
      "¡Amamos la experiencia! Todo estuvo genial: el anfitrión, el lugar, la comida, la compañía. ¡Disfrutamos muchísimo la noche!",
  },
  {
    author: "Luis",
    location: "Buenos Aires, Argentina",
    content_en:
      "The experience Diego offers is a masterclass on how to prepare an authentic local barbecue. Both the provoleta and the ribeye steak were the standout dishes. Many thanks, Diego, for your warmth and professionalism.",
    content_es:
      "La experiencia que ofrece Diego es una masterclass sobre cómo preparar un auténtico asado argentino. La provoleta y el ojo de bife fueron los platos destacados. Gracias Diego por tu calidez y profesionalismo.",
  },
  {
    author: "Juan",
    location: "Cali, Colombia",
    content_en:
      "Thank you, Diego, for such an amazing experience. Learning about the techniques, history, and culture of asado was spectacular. I would definitely stay here again every time I visit Argentina.",
    content_es:
      "Gracias Diego por una experiencia maravillosa. Aprender sobre las técnicas, historia y cultura del asado fue espectacular. Volvería cada vez que visite Argentina.",
  },
  {
    author: "Sebastián",
    location: "Ciudad de México, México",
    content_en:
      "Diego is a great host, and the experience is totally worth it. While the cuts are being prepared, Diego will tell you about the history of the asado. The food is delicious and the stay is very comfortable. I recommend it 100%.",
    content_es:
      "Diego es un gran anfitrión y la experiencia vale totalmente la pena. Mientras se preparan los cortes, Diego te cuenta sobre la historia del asado. La comida es deliciosa y la estancia muy cómoda. ¡Lo recomiendo 100%!",
  },
  {
    author: "Bettina",
    location: "Karlstadt am Main, Alemania",
    content_en:
      "Diego was a perfect host. We felt very comfortable. The food, the wine, the ambience, and his stories were fantastic.",
    content_es:
      "Diego fue un anfitrión perfecto. Nos sentimos muy cómodos. La comida, el vino, el ambiente y sus historias fueron fantásticas.",
  },
];

// Número de WhatsApp del anfitrión (el mismo que figura en el sitio: 11 5102-3381).
export const WHATSAPP_NUMBER = "5491151023381";
